export function isAenderbar(vorgang: object & { wurdeGutachtenVersandt?: boolean | null | undefined }): boolean {
  return !vorgang?.wurdeGutachtenVersandt;
}
